<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card p-4">
            <div class="card-body">
              <form @submit="changePassword">
                <h1>Change Password</h1>

                <p :class="{'text-muted': !changePasswordError, 'text-danger': changePasswordError}">
                  {{ !changePasswordError ? 'Change your password first to continue' : changePasswordError }}
                </p>

                <div class="form-group mt-4">
                  <label>Old Password</label>
                  <input v-model="oldPassword" type="password" class="form-control" required autocomplete="current-password" />
                </div>

                <div class="form-group mb-4">
                  <label>New Password</label>
                  <input v-model="newPassword" type="password" class="form-control" required autocomplete="current-password" />
                </div>

                <div class="form-group mb-4">
                  <label>Confirm New Password</label>

                  <input v-model="confirmNewPassword" type="password" class="form-control" required autocomplete="current-password" />
                  <div class="invalid-feedback d-block" v-if="submitAttempted && confirmNewPassword !== newPassword">
                    Passwords do not match
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <button :class="{disabled: changingPassword}" class="btn btn-primary px-4">
                      {{ !changingPassword ? 'Submit' : 'Please Wait...' }}
                    </button>
                  </div>
                  <!-- <b-col cols="6" class="text-right">
                    <b-button variant="link" class="px-0">Forgot password?</b-button>
                  </b-col> -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { changeStaffUserPassword } from '../../services/API'
  import { saveUser, getUser } from '../../services/auth'

  export default {
    name: 'Change Password',
    data(){
      return {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        changingPassword: false,
        submitAttempted: false,
        changePasswordError: false
      }
    },
    methods: {
      async changePassword(e){
        e.preventDefault();
        this.submitAttempted = true;
        if(this.confirmNewPassword !== this.newPassword)
            return;

        this.changingPassword = true;
        this.changePasswordError = false;

        try {
          await changeStaffUserPassword({oldPassword: this.oldPassword, password: this.newPassword});
          this.changingPassword = false;
          this.oldPassword = "";
          this.newPassword = "";
          this.confirmNewPassword = "";
          let authUser = await getUser();
          if(authUser)
            authUser = JSON.parse(authUser);

          authUser.staffFirstTimeLoginFlag = 1;
          this.$store.dispatch('setAuthUser', authUser);
          this.$router.replace('/');
          await saveUser(authUser);
        } catch (error) {
          this.changingPassword = false;
          if(error.response){
            this.changePasswordError = error.response.data.userMessage;

            setTimeout(() => {
              this.changePasswordError = null
            }, 2000);
          }
          else{
            console.log(error);
          }
        }
      }
    }
  }
</script>
